"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const conf_1 = require("./conf");
const dataFormat_1 = require("./utils/dataFormat");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const __sfc_main = {};
__sfc_main.props = {
    optionType: {
        type: String,
        default: conf_1.OPTION_TYPE_MAP.ALL
    },
    stockIds: {
        type: Array,
        default: () => []
    },
    expiryDaysLimit: {
        type: Object,
        default: () => conf_1.EXPIRATION_TIME_FILTER_LIST[0].value
    },
    requestUnusualCount: {
        type: Number,
        default: conf_1.DEFAULT_REQUEST_UNUSUAL_COUNT
    },
    showFieldArr: {
        type: Array,
        default: () => []
    },
    regionType: {
        type: String,
        default: conf_1.REGION_TYPE_MAP.SG
    },
    sortField: {
        type: Number,
        default: conf_1.SORT_FIELD.EVENT_TIME
    },
    maxDayNum: {
        type: Number,
        default: 1
    },
    expiryDaysLimitIndex: {
        type: Number,
        default: 0
    },
    marketType: {
        type: Number,
        default: conf_1.MARKET_TYPE_MAP.US_STOCK
    }
};
__sfc_main.setup = (__props, __ctx) => {
    /* eslint-disable @typescript-eslint/no-magic-numbers */
    // 这里使用 require 避免类型声明差异导致的构建期报错（运行时行为不变）
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { computed, onMounted, ref, watch } = require('vue-demi');
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const request = require('../assets/scripts/request').default || require('../assets/scripts/request');
    const locales = require('./locales').default || require('./locales');
    const { useI18n, useLang, useToast, isPreRender } = require('@fegobull/webapi').use;
    const Toast = useToast();
    const { langText, lang } = useLang();
    const props = __props;
    const emit = __ctx.emit;
    const $tran = useI18n(locales[props.regionType || conf_1.REGION_TYPE_MAP.SG]);
    const optionsInfo = ref([]);
    const showMore = ref(false);
    const loading = ref(false);
    const PAGE_SIZE = 2;
    // 获取展示字段
    const showFieldInfo = computed(() => {
        const ret = [];
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        const showFieldArr = (props.showFieldArr || []);
        const len = Math.min(showFieldArr.length, conf_1.MAX_FIELD_LEN);
        for (let i = 0; i < len; i++) {
            const dataLabel = showFieldArr[i] && showFieldArr[i].dataLabel || showFieldArr[i] || '';
            if (dataLabel) {
                ret.push({
                    name: $tran(dataLabel) || '',
                    dataLabel: String(dataLabel)
                });
            }
        }
        return ret;
    });
    // 获取需要格式化的字段列表
    const formatFieldList = computed(() => {
        const fieldList = [];
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        const showFieldArr = (props.showFieldArr || []);
        const len = Math.min(showFieldArr.length, conf_1.MAX_FIELD_LEN);
        for (let i = 0; i < len; i++) {
            const dataLabel = showFieldArr[i] && showFieldArr[i].dataLabel || showFieldArr[i] || '';
            if (dataLabel) {
                fieldList.push(String(dataLabel));
            }
        }
        return fieldList;
    });
    // 所有数据（直接使用数组，保持服务返回的顺序）
    const allData = computed(() => optionsInfo.value || []);
    // 是否显示更多按钮
    const showMoreIcon = computed(() => allData.value.length > PAGE_SIZE);
    // 当前展示的数据
    const optionList = computed(() => {
        if (showMore.value) {
            return allData.value;
        }
        return allData.value.slice(0, PAGE_SIZE);
    });
    // 涨跌幅颜色类
    const rateColorCls = computed(() => {
        // 这里简单给个默认值，或者根据 regionType 判断
        // 实际逻辑可能在 common.less 或其他地方有处理
        return '';
    });
    const getFilter = () => {
        return {
            optionType: props.optionType,
            stockIdList: props.stockIds,
            expiryDaysLimit: conf_1.EXPIRATION_TIME_FILTER_LIST[props.expiryDaysLimitIndex].value,
            maxDayNum: props.maxDayNum
        };
    };
    /**
     * 获取异动期权列表
     */
    const getUnusualOptionList = async () => {
        try {
            loading.value = true;
            if (Toast)
                Toast.loading(conf_1.NUM_MAP.TEN);
            // 增加loading时间，确保框架先显示
            await new Promise(resolve => setTimeout(resolve, 300));
            const { eventList } = await request.getOptionEventList({
                count: props.requestUnusualCount,
                filter: Object.assign({}, getFilter()),
                sortField: props.sortField
            });
            // 直接使用数组存储，保持服务返回的顺序
            const formattedList = [];
            (eventList || []).forEach((item) => {
                const { optionId } = item || {};
                if (optionId) {
                    // 只格式化 showFieldArr 中指定的字段
                    const formatted = (0, dataFormat_1.formatItemData)(item, formatFieldList.value, $tran, lang);
                    formattedList.push(formatted);
                }
            });
            // 直接替换数组，保持服务返回的顺序
            optionsInfo.value = formattedList;
        }
        catch (error) {
            if (Toast)
                Toast.error((error === null || error === void 0 ? void 0 : error.message) || 'fail');
        }
        finally {
            loading.value = false;
            if (Toast)
                Toast.close();
        }
    };
    const jumpToDetail = (optionsItem) => {
        const optionId = optionsItem === null || optionsItem === void 0 ? void 0 : optionsItem.optionId;
        window.location.href = `futunn://quote/stockDetailV2?stockID=${optionId}`;
    };
    onMounted(() => {
        if (!isPreRender) {
            getUnusualOptionList();
        }
    });
    watch(() => props, () => {
        if (!isPreRender) {
            getUnusualOptionList();
        }
    }, {
        deep: true
    });
    return {
        langText,
        props,
        $tran,
        showMore,
        loading,
        PAGE_SIZE,
        showFieldInfo,
        showMoreIcon,
        optionList,
        rateColorCls,
        jumpToDetail
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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